<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة معاملة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/pTransactions">المعاملات المالية للمزود</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة معاملة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <!--begin::Header-->
              <div class="card-header"><div class="card-title">إضافة معاملة</div></div>
              <!--end::Header-->
              <!--begin::Form-->
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <successAlert v-if="hasSucess" :message="message" />

              <mainLoader v-if="mainLoading" />

              <form v-if="!mainLoading" @submit.prevent="subimtData()">
                <!--begin::Body-->
                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="alert alert-warning">انتبه: يرجى تحري الدقة حيث ان هذا الإجراء لا يمكن التراجع عنه</div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label" for="">المزود:</label>
                      <input type="text" class="form-control" placeholder="جوال المزود" @keyup="getProviderData()" v-model="userMobile">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <loader v-if="userLoader" />
                      <div v-if="userName">
                        <label class="form-label" for="">اسم المزود:</label>
                        <div>{{ userName }}</div>
                        <div>الرصيد الحالي: {{ userBalance }} ريال</div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">وصف عربي: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="title">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">الوصف انجليزي: <span class="req">*</span></label>
                      <input type="text" class="form-control english-input" v-model="titleEn">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">القيمة: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="amount" @input="$event.target.value = $event.target.value.replace(/[^0-9.]/g, '')" />
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">نوع العملية: <span class="req">*</span></label>
                      <select v-model="transType" class="form-control">
                        <option :value="null">اختر العملية</option>
                        <option v-for="(val, key) in transactionsTypes" :value="key" :key="key">{{ val }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="" class="form-label">رقم الطلب إن وجد:</label>
                      <input type="text" class="form-control" v-model="orderId" @input="$event.target.value = $event.target.value.replace(/[^0-9]/g, '')" />
                    </div>
                  </div>
                </div>
                <!--end::Body-->
                <!--begin::Footer-->
                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
                      <loader v-if="formLoader" />
                    </div>
                  </div>
                </div>
                <!--end::Footer-->
              </form>
              <!--end::Form-->
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'PTransactionsCreate',
  data() {
    return {
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      mainLoading: true,
      formLoader: false,
      userLoader: false,
      userMobile: null,
      userName: null,
      userBalance: 0,
      // for form 
      providerId: null,
      title: null,
      titleEn: null,
      amount: 0,
      transactionsTypes: {},
      transType: null,
      orderId: null,
    };
  },
  methods: {
    subimtData(){
      if(!this.providerId || !this.transType || !this.amount || !this.title || !this.titleEn){
        this.message = 'كل البيانات مطلوبة';
        this.errorNumber = 0;
        this.hasError = true;
        this.formLoader = false;
        window.scroll(0,0);
        return;
      }

      const payload = {
        providerId: this.providerId,
        title: this.title,
        titleEn: this.titleEn,
        amount: this.amount,
        transType: this.transType,
        orderId: this.orderId,
      }

      this.$http.post('/api/admin/pTransactions/create', payload).then(({data}) => {
        toast('تم إضافة الإعلان بنجاح', 'success');
        this.$router.replace(`/pTransactions?page=1`).catch(() => {});
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    getProviderData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.userLoader = true;
        this.providerId = null;
        this.userName = null;
        this.$http.post('/api/admin/orders/getProvider', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.providerId = data.provider.id;
          this.userName = data.provider.name;
          this.userBalance = data.provider.balance;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    getInitData(){
      this.$http.get('/api/admin/pTransactions/init').then(({data}) => {
        this.transactionsTypes = data.transactionsTypes;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created() {
    this.getInitData();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
}
</script>
